module.exports = __webpack_public_path__ + "media/images/writer/home/kv-bg-phone-192a38f24f88b94b6e5c932e4ba3f9ff.png";